import { EventTrackerStatusEnum, EventTypeCodeEnum } from '@src/entities/Event/includes/schemas';
import { z } from 'zod';

export const SaveEventSchema = z.object({
  actualRecordCount: z.number().int(),
  associatedActionPathId: z.string().optional(),
  endDate: z
    .string()
    .refine(
      (val) => {
        return /^\d{4}-\d{2}-\d{2}$/.test(val);
      },
      { message: 'Invalid date format (expected YYYY-MM-DD)' }
    )
    .optional(),
  eventId: z.string().optional(),
  eventTrackerStatus: EventTrackerStatusEnum,
  eventTypeCode: EventTypeCodeEnum,
  expectedRecordCount: z.number().int(),
  impactedSystems: z.array(z.string()),
  notes: z.string(),
  startDate: z.string().refine(
    (val) => {
      return /^\d{4}-\d{2}-\d{2}$/.test(val);
    },
    { message: 'Invalid date format (expected YYYY-MM-DD)' }
  ),
  title: z.string(),
});
